import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createSplit } from '@/api/createSplit';
import { queryKeys } from '@/constants/queryKeys';

export const useCreateSplit = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createSplit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.bill(undefined), exact: false });
      // Refetch split state so isSplitExist reflects the new split promptly —
      // an items-split universe is registered eagerly and the pay path reads
      // this state synchronously (see useItemsSplitPayment)
      queryClient.invalidateQueries({ queryKey: ['splitDetails'], exact: false });
    },
  });
};
